export const FightTypeSummaryCard = ({ fightType, dataTestId = "fight-type-summary" }) => {
  if (!fightType?.title) return null;

  return (
    <div data-testid={dataTestId} className="mt-3 border border-amber-900/40 bg-amber-950/10 px-4 py-3 rounded-sm text-left max-w-xl mx-auto">
      <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Fight Type</div>
      <div className="mt-1 font-cinzel text-amber-300 uppercase tracking-wide text-sm" data-testid={`${dataTestId}-title`}>
        {fightType.title}
      </div>
      <p className="mt-1 text-sm text-zinc-400" data-testid={`${dataTestId}-description`}>
        {fightType.description}
      </p>
    </div>
  );
};